import script from "./AddDirectivesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDirectivesModal.vue?vue&type=script&setup=true&lang=js"

import "./AddDirectivesModal.vue?vue&type=style&index=0&id=144889ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-144889ed"]])

export default __exports__